import { z } from "zod";

import { createEventFactory } from "../gtm";

export const addressSelectionGtmEvent = createEventFactory(
  "address_selection",
  z.object({
    selected_city: z.string(),
    zone_id: z.number().nullable(),
    selected_address: z.string(),
  }),
);
